import { useEffect } from 'react'

import { useTexts } from '../../hooks/useTexts'
import { createValidateCompanies } from '../../hooks/validations/createValidateCompanies'
import { useCompanies } from './hooks/useCompanies'

import { form } from '../../formState'

type Props = {
  creating: boolean
}

export function CompaniesList(props: Props) {
  const { creating } = props

  const formApi = form.useFormApi()

  const { companies: options } = useCompanies()

  const texts = useTexts()

  form.useAddFieldValidation<'companies'>(
    'companies',
    (field, _formApi) => {
      const validationCompanies = createValidateCompanies(texts, field.value)

      return validationCompanies.companiesRequiredError?.message
    },
    { customUID: 'companiesRequiredError' },
  )

  useEffect(() => {
    //validate company field on edit in initial render to check missing company
    if (!creating) {
      formApi.validate('companies')
    }
  }, [formApi, creating])

  useEffect(() => {
    const unsubscribe = formApi.subscribeToField('isCompanyFiltered', field => {
      // toggle the required state of the companies field
      // changing the required state will invalidate the field
      if (!field.value) {
        formApi.clearError('companiesRequiredError')
        formApi.change('companies', [])
      }
    })

    return () => {
      unsubscribe()
    }
  }, [formApi])

  return (
    <form.MultiSelect
      name="companies"
      testId="companies"
      validateOn="blur change"
      multiSelectProps={{
        label: texts.labels.companies,
        items: options,
        getLabel: c => c.name,
        getOptionDisabled: c => !c.enabled,
        inputMode: 'normal',
        optionMode: 'normal',
        texts: texts.multiSelect.companies,
        autocompleteProps: {
          isOptionEqualToValue: (o1, o2) => o1.id === o2.id,
        },
      }}
    />
  )
}
